<template>
  <el-row style="width: 100%;margin-top: 115px;">
    <el-row style="height: calc(100% - 116px);overflow-y: auto;">
      <!--  轮播图  -->
      <el-row style="height: 240px;width: 100%;">
        <el-carousel :interval="4000" trigger="click" arrow="always" height="240px">
          <el-carousel-item v-for="(item, i) in imgList" :key="i">
            <el-row :style="{backgroundImage: 'url(' + item + ')'}" class="top-img-class">
            </el-row>
          </el-carousel-item>
        </el-carousel>
      </el-row>
      <el-row style="width: 100%;margin-top: 20px;">
        <slot>
        </slot>
      </el-row>
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: 'ProdPage',
  props: ['id', 'selId'],
  data() {
    return {
      imgList: [require('../../assets/product.jpg')]
    }
  },
  methods: {}
}
</script>

<style scoped>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  .top-img-class {
     width: 100%;
     height: 240px;
     background-size: cover;
     background-position: center;
     background-repeat: no-repeat;
   }
</style>



// WEBPACK FOOTER //
// src/components/product/ProdPage.vue